import { render } from "./ArticleDetailPage.vue?vue&type=template&id=20e4b50b&scoped=true"
import script from "./ArticleDetailPage.vue?vue&type=script&lang=js"
export * from "./ArticleDetailPage.vue?vue&type=script&lang=js"

import "./ArticleDetailPage.vue?vue&type=style&index=0&id=20e4b50b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e4b50b"]])

export default __exports__